const Types = {    
    TIPO: '@menu-protocolo/TIPO',
    TIPOSAGA: '@menu-protocolo/TIPOSAGA'
   
};

export default Types;